<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" v-if="$myStore.state.user.user_role_id != 3">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="objectsTable.additionalFilters"
                                    :default-sort="objectsTable.defaultSort"
                                    :excel="true"
                                    :fields="objectsTable.headers"
                                    :header-selection-key="'vacancies-headerss'"
                                    :height="objectsTable.height"
                                    :total-records="objectsTable.total"
                                    :filter-save-key="'vacancies-filterss'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in objectsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('status')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-chip
                                                v-if="item.status_id == 1"
                                                class="text-uppercase pl-4"
                                                text-color="#008000"
                                                color="#00800040"
                                                ><v-icon x-small left color="#008000"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.status_id == 2"
                                                class="text-uppercase pl-4"
                                                text-color="#4360DF"
                                                color="#4360DF40"
                                                ><v-icon x-small left color="#4360DF"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.status_id == 3"
                                                class="text-uppercase pl-4"
                                                text-color="#6F6F6F"
                                                color="#6F6F6F40"
                                                ><v-icon x-small left color="#6F6F6F"> fas fa-circle </v-icon
                                                >{{ item.status_display }}</v-chip
                                            >
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('job_title')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.job_title }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('rank_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.ranks_display }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('entity')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.entity_name }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('maritime_object')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip bottom v-if="item.maritime_objects_hover">
                                                <template v-slot:activator="{on, attrs}">
                                                    <span v-bind="attrs" v-on="on">
                                                        {{ item.maritime_objects_display }}</span
                                                    >
                                                </template>
                                                <span>{{ item.maritime_objects_hover }}</span>
                                            </v-tooltip>
                                            <span v-else> {{ item.maritime_objects_display }}</span>
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('number_of_offered_positions')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.number_of_offered_positions }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('applications')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.applications }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('placements')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.placements }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('joining_date')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.joining_date_display }}
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="objectsTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-btn v-if="item.active" x-small color="#00800040" fab depressed>
                                                <v-icon x-small color="#008000">fas fa-check</v-icon></v-btn
                                            >
                                            <v-btn v-else x-small color="#6F6F6F40" fab depressed>
                                                <v-icon x-small color="#6F6F6F">fas fa-minus</v-icon></v-btn
                                            >
                                        </td>

                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Vacancies',
    components: {TheTable},
    data: function () {
        return {
            objectsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true, width: '60px'},
                    {
                        text: this.$t('fields.status'),
                        value: 'status',
                        type: 'dropdown|vacancy-statuses',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.jobTitle'), value: 'job_title', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.rank'),
                        value: 'rank_id',
                        type: 'multiple|ranks-abbreviation',
                        sortable: false,
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.entity'),
                        value: 'entity',
                        type: 'dropdown|entities',
                        allowFilter: true,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.maritimeObject'),
                        value: 'maritime_object',
                        type: 'dropdown|maritime-objects',
                        allowFilter: true,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.positionsOffererdNo'),
                        value: 'number_of_offered_positions',
                        type: 'string',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.applied'),
                        value: 'applications',
                        type: 'string',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.hired'),
                        value: 'placements',
                        type: 'string',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.joiningData'), value: 'joining_date', type: 'date', allowFilter: true},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },

                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'created_at',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/vacancies/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/vacancies/' + id);
            } else {
                let routeData = this.$router.resolve('/vacancies/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.objectsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'vacancies', request, (data, success) => {
                if (success) {
                    vm.objectsTable.items = data.items;
                    vm.objectsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'vacancies',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/vacancies', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.objectsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.vacancies'), href: '/#/vacancies', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resolveWindowResize);
    },
};
</script>

<style scoped></style>
